/* global attachEvent */
// **************************************************
// Form validation
// **************************************************
if (document.querySelector('.contact-form')) {
  const button = document.querySelector('.contact-form__submit .btn');
  const contactForm = document.querySelector('.contact-form');
  const sendAjax = () => {
    const formData = {};
    document.querySelectorAll('.contact-form input, .contact-form textarea').forEach((input) => {
      let type = input.tagName === 'TEXTAREA' ? input.tagName : input.getAttribute('type');
      switch (type) {
        case 'text':
        case 'TEXTAREA':
        case 'hidden':
        case 'email':
          formData[input.name] = input.value.trim();
          const invalid = (!/^[\w\d._-]+@[\w\d\-_.]+\.[\d\w][\d\w]+$/.test(formData[input.name]) && type === 'email') || input.value.length === 0;
          input.closest('.form-group').classList.toggle('is-validation-failed', invalid);
          break;
        case 'checkbox':
          if (input.required) {
            input.closest('.checkbox').classList.toggle('is-validation-failed', !input.checked);
          }
          formData[input.name] = input.checked;
          break;
        default:
      }
    });

    // const textArea = document.querySelector('.contact-form textarea');
    // textArea?.classList.toggle('is-validation-failed', textArea.value === '');

    const validationFailed = document.querySelectorAll('.form-group.is-validation-failed').length > 0 || document.querySelectorAll('.checkbox.is-validation-failed').length > 0;
    if (!validationFailed) {
      const ajax = new XMLHttpRequest();
      const formDataInput = new FormData();
      formDataInput.append('action', 'submitForm');
      formDataInput.append('lang', localData.lang);
      formDataInput.append('type', contactForm.dataset.type);
      formDataInput.append('inputs', JSON.stringify(formData));
      // if (typeof textArea !== 'undefined') {
      //   formDataInput.append('textarea', JSON.stringify(textArea));
      // }
      ajax.open('POST', localData.siteURL, true);
      ajax.onload = () => {
        const response = JSON.parse(ajax.responseText);
        if (response.data?.status === 400) {
          contactForm.querySelector('.editor-text').innerHTML = response.data?.thankyou_message  || '';
        }
        contactForm.classList.add('thankyou-visible');
      };
      ajax.send(formDataInput);
    }
  };

  button.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    sendAjax();
  });
}

// **************************************************
// Go back button
// **************************************************
attachEvent('.contact-form__back-link', 'click', (ev) => {
  // eslint-disable-next-line no-restricted-globals
  history.back();
  ev.preventDefault();
});
